import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

const PRICE_VARIANT = `${API_URL}variant-prices`

export const getPriceVariant = async (token: string) => {
  return axios.get(
    PRICE_VARIANT,
    {
      headers: {
        'X-Auth-token': token,
      },
    }
  )
}

export const insertPriceVariant = async (variantPriceName: string, note: string, token: string) => {
  return axios.post(
    PRICE_VARIANT,
    {
      variantPriceName,
      note,
    },
    {
      headers: {
        'X-Auth-token': token,
      },
    }
  )
}

export const updateVariantPrice = async (
  variantPriceName: string,
  note: string,
  id: string,
  token: string
) => {
  return axios.put(
    PRICE_VARIANT + '/' + id,
    {
      variantPriceName,
      note,
    },
    {
      headers: {
        'X-Auth-token': token,
      },
    }
  )
}

export const deletePriceVariant = async (id: string, token: string) => {
  return axios.delete(PRICE_VARIANT + '/' + id, {
    headers: {
      'X-Auth-token': token,
    },
  })
}
